import { Box, Tab } from "@material-ui/core";
import { TabsCustom, useAdminStyles } from "Globals/Styles/AdminStyling";

import { AdminHome } from "./AdminHome";
import { AppHeader } from "@shoothill/core";
import React from "react";
import { RolesList } from "./RolesList";
import Typography from "@material-ui/core/Typography";
import { UsersList } from "./UsersList";
import { useObserver } from "mobx-react-lite";

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <Typography component="div" role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            <Box>{children}</Box>
        </Typography>
    );
}

function a11yProps(index: any) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export const Admin: React.FC = () => {
    // const classes = useAdminStyles();
    // const [value, setValue] = React.useState(0);

    // function handleChange(event: React.ChangeEvent<{}>, newValue: number) {
    //     setValue(newValue);
    // }

    return useObserver(() => (
        <>
            {/* <div>
                <AppHeader className={classes.adminHeader}>
                    <div className={classes.tabsContainer}>
                        <TabsCustom value={value} onChange={handleChange} aria-label="simple tabs example" className={classes.tabsWidth}>
                            <Tab label="Dashboard" {...a11yProps(0)} />
                            <Tab label="Manage users" {...a11yProps(1)} />
                            <Tab label="Manage roles" {...a11yProps(2)} />
                        </TabsCustom>
                    </div>
                </AppHeader>
            </div>

            <TabPanel value={value} index={0}>
                <AdminHome />
            </TabPanel>
            <TabPanel value={value} index={1}> */}
            <UsersList />
            {/* </TabPanel>
            <TabPanel value={value} index={2}>
                <RolesList />
            </TabPanel> */}
        </>
    ));
};
